var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-event-type.392b9338.png","uri@2x": __webpack_public_path__ + "icon-event-type.5231bcf6.png","uri@3x": __webpack_public_path__ + "icon-event-type.deadb07b.png",
    width: 36,
    height: 35
});